import React from 'react';

import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const CustomTabPanel = (props) => {
    const { children, selectedTab, value, ...other } = props;

    return (
        <Box
            hidden={value !== selectedTab}
            id={`tabpanel-${value}`}
            role="tabpanel"
            {...other}
        >
            <Box sx={{ py: 2 }}>
                <div>{children}</div>
            </Box>
        </Box>
    );
};

CustomTabPanel.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CustomTabPanel;
